import { useGetIdentity } from "@refinedev/core";

export const useIsAdminRole = () => {
  const { data: identity } = useGetIdentity<{
    role: string;
  }>();

  return identity?.role.includes("ADMIN") || false;
};
